import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import {confirmAlert} from "react-confirm-alert";

export const fetchHiringRegions = async () => {
	let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
	model.limit = 5000;
	let regions = await model.submit(null, 'GET_ALL');
	regions = Object.keys(regions).map((key) => regions[key]);
	regions = regions[3];
	regions = regions.sort(function (a, b) {
		return a.name.localeCompare(b.name)
	});
	return regions.filter((region) => {
		return region.latitude > 0 || region.latitude < 0
	});
}

export const getRegionMeta = (regionPkey, hiringRegions) => {
	return hiringRegions.find((region) => region.pkey == regionPkey);
}

export const getRegionName = (regionPkey, hiringRegions, regionObject = null) => {
	const meta = getRegionMeta(regionPkey, hiringRegions);
	if (meta?.name) {
		return meta.name;
	}
	if (regionObject?.pkey == regionPkey && regionObject?.name) {
		return regionObject.name;
	}
	return 'Unknown region';
}

export const isRegionHiring = (regionPkey, hiringRegions, regionObject = null) => {
	if (!regionPkey) {
		return true;
	}
	const meta = getRegionMeta(regionPkey, hiringRegions);
	if (meta) {
		return meta.active_zone === 'true';
	}
	if (regionObject?.pkey == regionPkey) {
		return regionObject.active_zone === 'true';
	}
	return true;
}

const alertMessages = {
	region: (regionName) =>
		`The selected service region (${regionName}) is not currently hiring. You must acknowledge this warning before continuing.`,
	save: (regionName) =>
		`Are you sure you want to save this candidate in ${regionName}? This region is not currently hiring.`,
	promote: (regionName) =>
		`Are you sure you want to promote this candidate? Their service region (${regionName}) is not currently hiring.`,
};

export const showNonHiringRegionAlert = ({context, regionName}) => {
	const isAction = context === 'save' || context === 'promote';
	return new Promise((resolve) => {
		confirmAlert({
			title: isAction ? 'Confirm' : 'Region Not Hiring',
			message: alertMessages[context](regionName),
			buttons: isAction
				? [
					{
						label: 'Yes',
						onClick: () => resolve(true)
					},
					{
						label: 'No',
						onClick: () => resolve(false)
					}
				]
				: [
					{
						label: 'I Understand',
						onClick: () => resolve(true)
					}
				],
			closeOnClickOutside: false,
			closeOnEscape: false,
			onClose: () => resolve(false)
		});
	});
}

export const ensureNonHiringRegionAcknowledged = async ({
	regionPkey,
	hiringRegions,
	regionObject,
	context = 'save',
	requireRegionAck = true,
}) => {
	if (!regionPkey || isRegionHiring(regionPkey, hiringRegions, regionObject)) {
		return true;
	}

	const regionName = getRegionName(regionPkey, hiringRegions, regionObject);

	if (requireRegionAck) {
		const acknowledged = await showNonHiringRegionAlert({context: 'region', regionName});
		if (!acknowledged) {
			return false;
		}
	}

	const confirmed = await showNonHiringRegionAlert({context, regionName});
	return confirmed;
}
